import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-title">
        <div className="company-name">Simplistic Creations</div>
        <div className="quote">Life isn't about finding yourself, it's about creating yourself.</div>
      </div>
        <div className="nav-container">
          <input className="side-menu" type="checkbox" id="side-menu"/>
          <label className="hamb" htmlFor="side-menu">
            <span className="hamb-line"></span>
          </label>
          <nav>
            <ul className="menu">
              <li><Link to="/photography">Photography</Link></li>
              <li><Link to="/software-engineering">Software Engineering</Link></li>
              <li><Link to="/music">Music</Link></li>
            </ul>
          </nav>
        </div>
    </header>
  );
};

export default Header;